import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AssetValuation  {
    _originalTypeClassName = "zERP.BO.AssetValuation";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AssetValuation.translate = translateService;
}
this.Id = null;
this.AccumulatedDepreciationValue = null;
this.NonDepreciatedValue = null;
this.RealValue = null;
this.AccumulatedImprovementValue = null;
this.AccumulatedAdjustmentValue = null;
this.AccumulatedDestructionOrSaleValue = null;
this.AccumulatedSubsidyValue = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
AccumulatedDepreciationValue:any;
NonDepreciatedValue:any;
RealValue:any;
AccumulatedImprovementValue:any;
AccumulatedAdjustmentValue:any;
AccumulatedDestructionOrSaleValue:any;
AccumulatedSubsidyValue:any;
TaxAsset:any;
AccountingAsset:any;
static setTaxAsset = ($this, value) => {
var oldValue = $this.TaxAsset;
$this.TaxAsset = value;
if (value != null) {
if (oldValue != null && oldValue.TaxValuation != null) { oldValue.TaxValuation = null; }
if ($this.TaxAsset.TaxValuation !== $this) {
Domain.Asset.setTaxValuation(value, $this);
}
}
}
static setAccountingAsset = ($this, value) => {
var oldValue = $this.AccountingAsset;
$this.AccountingAsset = value;
if (value != null) {
if (oldValue != null && oldValue.AccountingValuation != null) { oldValue.AccountingValuation = null; }
if ($this.AccountingAsset.AccountingValuation !== $this) {
Domain.Asset.setAccountingValuation(value, $this);
}
}
}

static GetAsset($this: any): any{if ($this?.TaxAsset != null) {return $this?.TaxAsset;}else if ($this?.AccountingAsset != null) {return $this?.AccountingAsset;}else {throw Error("One asset must be non null");}
}
static GetDepreciationType($this: any): any{if ($this?.TaxAsset != null) {return Domain.AssetDepreciationType.TaxBase;}else if ($this?.AccountingAsset != null) {return Domain.AssetDepreciationType.AccountingBase;}else {throw Error("One asset must be non null");}
}
static GetNonDepreciatedValue($this: any): any{let asset = Domain.AssetValuation.GetAsset($this);
let value = Joove.Common.safeNumber(0) + Joove.Common.safeNumber(asset?.PurchaseValue) - Joove.Common.safeNumber($this?.AccumulatedDepreciationValue) + Joove.Common.safeNumber($this?.AccumulatedImprovementValue) + Joove.Common.safeNumber($this?.AccumulatedAdjustmentValue) - Joove.Common.safeNumber($this?.AccumulatedDestructionOrSaleValue) - Joove.Common.safeNumber($this?.AccumulatedSubsidyValue);
if (Domain.AssetValuation.GetDepreciationType($this) == Domain.AssetDepreciationType.TaxBase) {return Math.max(value, asset?.TaxDepreciationCategory?.MarginalSalvageValue);}else {return Math.max(value, asset?.AccountingDepreciationCategory?.MarginalSalvageValue);}
}
static GetRealValue($this: any): any{return Joove.Common.safeNumber(Domain.AssetValuation.GetNonDepreciatedValue($this)) + Joove.Common.safeNumber($this?.AccumulatedSubsidyValue);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}